import React, { useState } from "react";
import Input from "./Input";
import FormCheck from "./FormCheckbox";
import { Col } from "react-bootstrap";
import DatePicker from "./DatePicker";
import Textarea from "./Textarea";

interface CustomState {
  customField?: any;
  setCustom?: any;
  userId?: string;
  userType?: string;
  enableSave?: any;
  setSaveIsEnabled?: any;
  columns?: number;
  myCase?: boolean;
  editMode?: boolean;
}

const CustomField = ({
  customField,
  setCustom,
  userId,
  userType,
  enableSave,
  setSaveIsEnabled,
  columns = 4,
  myCase = true,
  editMode = false,
}: CustomState) => {
  const [value, setValue] = useState<string | boolean | null>(customField?.value ? customField?.value : null);

  const onUpdateValue = (e: any) => {
    const newValue = customField?.type === "date" ? e : customField?.type === "checkbox" ? !value : e.target.value;
    setValue(newValue);

    setCustom((prev: any[]) => {
      const fieldId = customField?.field_id ?? customField?.id;
      const existingIndex = prev.findIndex((item) => item.field_id === fieldId);

      if (existingIndex !== -1) {
        // update existing field
        const updated = [...prev];
        updated[existingIndex] = {
          ...updated[existingIndex],
          person_id: userId,
          person_type: userType,
          value: newValue,
        };
        return updated;
      } else {
        // add new field
        return [...prev, { field_value_id: customField?.field_value_id, field_id: fieldId, value: newValue }];
      }
    });

    if (enableSave) {
      const validation = enableSave();
      setSaveIsEnabled(validation.isValid);
    }
  };

  return (
    <Col
      xs={12}
      lg={customField?.type === "multi-line text" ? 12 : columns}
      className={customField?.type === "checkbox" ? "d-flex align-items-center" : ""}
    >
      {customField?.type === "text" ? (
        <Input
          label={customField?.label}
          type="text"
          value={value}
          onUpdate={(e: any) => onUpdateValue(e)}
          disabled={myCase ? false : true}
          readOnly={!editMode}
          css={editMode ? "mb-3" : "mb-0"}
        />
      ) : customField?.type === "checkbox" ? (
        <FormCheck
          label={customField?.label}
          value={value === "1" ? true : value === "0" ? false : value}
          onUpdate={(e: any) => onUpdateValue(e)}
          disabled={editMode && myCase ? false : true}
        />
      ) : customField?.type === "date" ? (
        <DatePicker
          label={customField?.label}
          currentValue={value}
          setCurrentValue={onUpdateValue}
          hasMaxDate={false}
          disabled={myCase ? false : true}
          readOnly={!editMode}
          css={editMode ? "mb-3" : "mb-0"}
        />
      ) : (
        customField?.type === "multi-line text" && (
          <Textarea
            label={customField?.label}
            value={value}
            rows={1}
            onUpdate={(e: any) => onUpdateValue(e)}
            disabled={myCase ? false : true}
            readOnly={!editMode}
            css={editMode ? "mb-3" : "mb-0"}
          />
        )
      )}
    </Col>
  );
};

export default CustomField;
